import React, { useEffect, useState } from "react";

function Viagem() {
  const [viagens, setViagens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [localPartida, setLocalPartida] = useState("");
  const [localChegada, setLocalChegada] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const fetchViagens = async () => {
    try {
      const response = await fetch("http://201.76.56.77/api/viagens/");
      const data = await response.json();
      setViagens(data);
    } catch (error) {
      console.error("Erro ao buscar viagens:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchViagens();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!localPartida || !localChegada) return;
    setSubmitting(true);

    try {
      const response = await fetch("http://201.76.56.77/api/viagens/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          local_partida: localPartida,
          local_chegada: localChegada,
        }),
      });

      if (response.ok) {
        const novaViagem = await response.json();
        setViagens([...viagens, novaViagem]);
        setLocalPartida("");
        setLocalChegada("");
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <h2>Carregando viagens...</h2>;

  return (
    <div style={{ padding: "2rem", fontFamily: "Arial, sans-serif" }}>
      <h1>Lista de Viagens</h1>

      <form onSubmit={handleSubmit} style={{ marginBottom: "2rem" }}>
        <input
          type="text"
          placeholder="Local de Partida"
          value={localPartida}
          onChange={(e) => setLocalPartida(e.target.value)}
          style={{ marginRight: "1rem", padding: "0.5rem" }}
        />
        <input
          type="text"
          placeholder="Local de Chegada"
          value={localChegada}
          onChange={(e) => setLocalChegada(e.target.value)}
          style={{ marginRight: "1rem", padding: "0.5rem" }}
        />
        <button
          type="submit"
          disabled={submitting}
          style={{ padding: "0.5rem 1rem" }}
        >
          {submitting ? "Enviando..." : "Adicionar Viagem"}
        </button>
      </form>

      {viagens.length === 0 ? (
        <p>Nenhuma viagem cadastrada.</p>
      ) : (
        <table
          border="1"
          cellPadding="10"
          cellSpacing="0"
          style={{ borderCollapse: "collapse", width: "100%" }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th>ID</th>
              <th>Local de Partida</th>
              <th>Local de Chegada</th>
            </tr>
          </thead>
          <tbody>
            {viagens.map((v) => (
              <tr key={v.id}>
                <td>{v.id}</td>
                <td>{v.local_partida}</td>
                <td>{v.local_chegada}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Viagem;
